/**
 * @generated SignedSource<<e18d2e396fa806e9afd0abdb79804942>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateTodoNumberResponseInput = {
  number?: number | null;
};
export type TodoEditNewMainFooterResponseNumberMutation$variables = {
  input: UpdateTodoNumberResponseInput;
  todoId: string;
};
export type TodoEditNewMainFooterResponseNumberMutation$data = {
  readonly todo: {
    readonly updateNumberResponse: {
      readonly canChangeStatus: boolean;
      readonly isResponseCompleted: boolean;
      readonly parent: {
        readonly canChangeStatus: boolean;
      } | null;
      readonly response: {
        readonly value?: number | null;
      } | null;
    };
  } | null;
};
export type TodoEditNewMainFooterResponseNumberMutation = {
  response: TodoEditNewMainFooterResponseNumberMutation$data;
  variables: TodoEditNewMainFooterResponseNumberMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "todoId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isResponseCompleted",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canChangeStatus",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "TodoResponseNumber",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoEditNewMainFooterResponseNumberMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateNumberResponse",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "response",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoEditNewMainFooterResponseNumberMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateNumberResponse",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "response",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b5db9edc33ca31c139fbf8ade42f4bff",
    "id": null,
    "metadata": {},
    "name": "TodoEditNewMainFooterResponseNumberMutation",
    "operationKind": "mutation",
    "text": "mutation TodoEditNewMainFooterResponseNumberMutation(\n  $todoId: ID!\n  $input: UpdateTodoNumberResponseInput!\n) {\n  todo(todoId: $todoId) {\n    updateNumberResponse(input: $input) {\n      isResponseCompleted\n      canChangeStatus\n      parent {\n        canChangeStatus\n        id\n      }\n      response {\n        __typename\n        ... on TodoResponseNumber {\n          value\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "09c37e9c151c7011685521cd8bc999d3";

export default node;
